import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="modal"
export default class extends Controller {
  static targets = ["container", "overlay", "panel"]

  connect() {
    this.isOpen = false
  }

  open(event) {
    if (event) event.preventDefault()
    this.isOpen = true

    this.containerTarget.classList.remove("hidden")

    this.overlayTarget.classList.remove("opacity-0")
    this.overlayTarget.classList.add("opacity-100")

    this.panelTarget.classList.remove("opacity-0", "translate-y-4", "sm:translate-y-0", "sm:scale-95")
    this.panelTarget.classList.add("opacity-100", "translate-y-0", "sm:scale-100")

    document.body.classList.add("overflow-hidden")
  }

  close(event) {
    if (event) event.preventDefault()
    this.isOpen = false

    this.overlayTarget.classList.remove("opacity-100")
    this.overlayTarget.classList.add("opacity-0")

    this.panelTarget.classList.remove("opacity-100", "translate-y-0", "sm:scale-100")
    this.panelTarget.classList.add("opacity-0", "translate-y-4", "sm:translate-y-0", "sm:scale-95")

    setTimeout(() => {
      if (!this.isOpen) {
        this.containerTarget.classList.add("hidden")
        document.body.classList.remove("overflow-hidden")
      }
    }, 200)
  }
}
